<template>
  <div id="app">
    <!-- 标题和返回按钮 -->
    <div class="evaluation_title">
      <div class="evaluation_titleBox">
        <!-- 左边返回按钮 -->
        <div class="evaluation_titleBack" @click="switchTo('/home')"></div>
        <span>{{evData.quanbupingjia}}</span>
      </div>
    </div>
    <div class="container">
      <mescroll-vue
        ref="mescroll"
        class="scrollView"
        :up="mescrollUp"
        :down="mescrollDown"
        @init="mescrollInit"
        v-show="type == 0"
      >
        <!-- 顶部全部评价 -->
        <div class="container_top" v-if="JSON.stringify(evData) != '{}'">
          <div
            @click="changeMenuStatus(indexEv)"
            :class=" { on: menuList == indexEv } "
            v-for="(itemEv,indexEv) in evData.review_top"
            :key="indexEv"
          >
            <span>
              {{itemEv.title}}
              <span
                class="container_topNumber"
                v-text="parseInt(itemEv.num) <= 999 ? '('+itemEv.num+')' : '('+itemEv.num+')'"
              ></span>
            </span>
          </div>
        </div>

        <div v-if="JSON.stringify(evData) != '{}'">
          <!-- 全部评价 -->
          <div v-if=" evData.review_info.length" class="scrollBox">
            <div v-for="(itemInfo,indexInfo) in evArr" :key="indexInfo">
              <!-- 客户评论 -->
              <div class="customer_commentsBox">
                <div class="customer_comments">
                  <!-- 头像 -->
                  <div class="customer_headrImg">
                    <img :src="itemInfo.user_pic" alt="头像" />
                  </div>
                  <!-- 名字和评价时间 -->
                  <div class="customer_nameTime">
                    <div>
                      <span>{{ itemInfo.user_name }}</span>
                    </div>
                    <div class="customer_time">
                      <span>{{itemInfo.input_time.slice(0,16)}}</span>
                    </div>
                  </div>
                  <!-- 星星指数 -->
                  <div class="customer_star">
                    <div class="starStyle" v-if="itemInfo.level <= 5 && itemInfo.level >0 ">
                      <img
                        src="https://aimg8.dlssyht.cn/u/1945298/ueditor/image/973/1945298/1569564083831652.png"
                        v-for="(itemStar,indexStar) in parseInt(itemInfo.level)"
                        :key="indexStar"
                        alt="star"
                      />
                    </div>
                    <div class="starStyle" v-if=" (5-parseInt(itemInfo.level)) > 0">
                      <img
                        src="https://aimg8.dlssyht.cn/u/1945298/ueditor/image/973/1945298/1569564136867556.png"
                        alt="noStar"
                        v-for="(itemStarSecond,indexStarSecond) in (5 - parseInt(itemInfo.level))"
                        :key="indexStarSecond"
                      />
                    </div>
                  </div>
                </div>

                <!-- 评价内容 -->
                <div class="customer_content">
                  <div class="customer_contentText">
                    <span>{{ itemInfo.content }}</span>
                  </div>

                  <!-- 图片 -->
                  <div class="customer_contentImgBox">
                    <div
                      class="customer_contentImg"
                      v-for="(itemPic,indexPic) in itemInfo.pic_arr"
                      :key="indexPic"
                    >
                      <img :src="itemPic" alt="图片" />
                    </div>
                  </div>
                  <!-- 商家回复 -->
                  <div class="customer_contentReply" v-if="itemInfo.shop_review != ''">
                    <span>
                      <span class="contentReply_name">{{ evData.shangjiahuifu }}:</span>
                      {{itemInfo.shop_review}}
                    </span>
                    <!-- 三角形 -->
                    <div class="customer_replySanjiao"></div>
                  </div>

                  <!-- 用户追评内容 -->
                  <div class="afterReview" v-if="itemInfo.user_review != '' || itemInfo.add_pic_arr.length">
                    <span class="user_review">{{ evData.yonghuzhuiping }}: {{ itemInfo.add_input_time }}</span>
                    <div class="customer_contentText">
                      <span>{{ itemInfo.user_review }}</span>
                    </div>

                    <!-- 图片 -->
                    <div class="customer_contentImgBox" v-if="itemInfo.add_pic_arr.length">
                      <div
                        class="customer_contentImg"
                        v-for="(itemPicAdd,indexPicAdd) in itemInfo.add_pic_arr"
                        :key="indexPicAdd"
                      >
                        <img :src="itemPicAdd" alt="图片" />
                      </div>
                    </div>
                    <!-- 商家回复 -->
                    <div class="customer_contentReply" v-if="itemInfo.add_shop_review != ''">
                      <span>
                        <span class="contentReply_name">{{ evData.shangjiahuifu }}:</span>
                        {{itemInfo.add_shop_review}}
                      </span>
                      <!-- 三角形 -->
                      <div class="customer_replySanjiao"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        
        <div v-if="evData.review_info.length == 0" class="noDataEva">
          <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/emptyArticle.png" alt="empty" />
          <span>{{ evData. zanshihaimeiyouxiangguanpingjia }}</span>
        </div>
        </div>
      </mescroll-vue>

      <mescroll-vue
        ref="mescroll2"
        class="scrollView"
        :up="mescrollUp2"
        :down="mescrollDown"
        @init="mescrollInit2"
        v-show="type == 1"
      >
        <!-- 顶部全部评价 -->
        <div class="container_top">
          <div
            @click="changeMenuStatus(indexEv)"
            :class=" { on: menuList == indexEv } "
            v-for="(itemEv,indexEv) in evData.review_top"
            :key="indexEv"
          >
            <span>
              {{itemEv.title}}
              <span
                class="container_topNumber"
                v-text="parseInt(itemEv.num) <= 999 ? '('+itemEv.num+')' : '('+itemEv.num+')'"
              ></span>
            </span>
          </div>
        </div>

        <div v-if="JSON.stringify(evData) != '{}'">
          <!-- 全部评价 -->
          <div v-if=" evData.review_info.length" class="scrollBox">
            <div v-for="(itemInfo,indexInfo) in evArr2" :key="indexInfo">
              <!-- 客户评论 -->
              <div class="customer_commentsBox">
                <div class="customer_comments">
                  <!-- 头像 -->
                  <div class="customer_headrImg">
                    <img :src="itemInfo.user_pic" alt="头像" />
                  </div>
                  <!-- 名字和评价时间 -->
                  <div class="customer_nameTime">
                    <div>
                      <span>{{ itemInfo.user_name }}</span>
                    </div>
                    <div class="customer_time">
                      <span>{{itemInfo.input_time.slice(0,16)}}</span>
                    </div>
                  </div>
                  <!-- 星星指数 -->
                  <div class="customer_star">
                    <div class="starStyle" v-if="itemInfo.level <= 5 && itemInfo.level >0 ">
                      <img
                        src="https://aimg8.dlssyht.cn/u/1945298/ueditor/image/973/1945298/1569564083831652.png"
                        v-for="(itemStar,indexStar) in parseInt(itemInfo.level)"
                        :key="indexStar"
                        alt="star"
                      />
                    </div>
                    <div class="starStyle" v-if=" (5-parseInt(itemInfo.level)) > 0">
                      <img
                        src="https://aimg8.dlssyht.cn/u/1945298/ueditor/image/973/1945298/1569564136867556.png"
                        alt="noStar"
                        v-for="(itemStarSecond,indexStarSecond) in (5 - parseInt(itemInfo.level))"
                        :key="indexStarSecond"
                      />
                    </div>
                  </div>
                </div>

                <!-- 评价内容 -->
                <div class="customer_content">
                  <div class="customer_contentText">
                    <span>{{ itemInfo.content }}</span>
                  </div>

                  <!-- 图片 -->
                  <div class="customer_contentImgBox">
                    <div
                      class="customer_contentImg"
                      v-for="(itemPic,indexPic) in itemInfo.pic_arr"
                      :key="indexPic"
                    >
                      <img :src="itemPic" alt="图片" />
                    </div>
                  </div>
                  <!-- 商家回复 -->
                  <div class="customer_contentReply" v-if="itemInfo.shop_review != ''">
                    <span>
                      <span class="contentReply_name">{{ evData.shangjiahuifu }}:</span>
                      {{itemInfo.shop_review}}
                    </span>
                    <!-- 三角形 -->
                    <div class="customer_replySanjiao"></div>
                  </div>

                  <!-- 用户追评内容 -->
                  <div class="afterReview" v-if="itemInfo.user_review != '' || itemInfo.add_pic_arr.length">
                    <span class="user_review">{{ evData.yonghuzhuiping }}: {{ itemInfo.add_input_time }}</span>
                    <div class="customer_contentText">
                      <span>{{ itemInfo.user_review }}</span>
                    </div>

                    <!-- 图片 -->
                    <div class="customer_contentImgBox" v-if="itemInfo.add_pic_arr.length">
                      <div
                        class="customer_contentImg"
                        v-for="(itemPicAdd,indexPicAdd) in itemInfo.add_pic_arr"
                        :key="indexPicAdd"
                      >
                        <img :src="itemPicAdd" alt="图片" />
                      </div>
                    </div>
                    <!-- 商家回复 -->
                    <div class="customer_contentReply" v-if="itemInfo.add_shop_review != ''">
                      <span>
                        <span class="contentReply_name">{{ evData.shangjiahuifu }}:</span>
                        {{itemInfo.add_shop_review}}
                      </span>
                      <!-- 三角形 -->
                      <div class="customer_replySanjiao"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        
        <div v-if="evData.review_info.length == 0" class="noDataEva">
          <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/emptyArticle.png" alt="empty" />
          <span>{{ evData. zanshihaimeiyouxiangguanpingjia }}</span>
        </div>
        </div>
      </mescroll-vue>

      <mescroll-vue
        ref="mescroll3"
        class="scrollView"
        :up="mescrollUp3"
        :down="mescrollDown"
        @init="mescrollInit3"
        v-show="type == 2"
      >
        <!-- 顶部全部评价 -->
        <div class="container_top">
          <div
            @click="changeMenuStatus(indexEv)"
            :class=" { on: menuList == indexEv } "
            v-for="(itemEv,indexEv) in evData.review_top"
            :key="indexEv"
          >
            <span>
              {{itemEv.title}}
              <span
                class="container_topNumber"
                v-text="parseInt(itemEv.num) <= 999 ? '('+itemEv.num+')' : '('+itemEv.num+')'"
              ></span>
            </span>
          </div>
        </div>
        <div v-if="JSON.stringify(evData) != '{}'">
          <!-- 全部评价 -->
          <div v-if=" evData.review_info.length" class="scrollBox">
            <div v-for="(itemInfo,indexInfo) in evArr3" :key="indexInfo">
              <!-- 客户评论 -->
              <div class="customer_commentsBox">
                <div class="customer_comments">
                  <!-- 头像 -->
                  <div class="customer_headrImg">
                    <img :src="itemInfo.user_pic" alt="头像" />
                  </div>
                  <!-- 名字和评价时间 -->
                  <div class="customer_nameTime">
                    <div>
                      <span>{{ itemInfo.user_name }}</span>
                    </div>
                    <div class="customer_time">
                      <span>{{itemInfo.input_time.slice(0,16)}}</span>
                    </div>
                  </div>
                  <!-- 星星指数 -->
                  <div class="customer_star">
                    <div class="starStyle" v-if="itemInfo.level <= 5 && itemInfo.level >0 ">
                      <img
                        src="https://aimg8.dlssyht.cn/u/1945298/ueditor/image/973/1945298/1569564083831652.png"
                        v-for="(itemStar,indexStar) in parseInt(itemInfo.level)"
                        :key="indexStar"
                        alt="star"
                      />
                    </div>
                    <div class="starStyle" v-if=" (5-parseInt(itemInfo.level)) > 0">
                      <img
                        src="https://aimg8.dlssyht.cn/u/1945298/ueditor/image/973/1945298/1569564136867556.png"
                        alt="noStar"
                        v-for="(itemStarSecond,indexStarSecond) in (5 - parseInt(itemInfo.level))"
                        :key="indexStarSecond"
                      />
                    </div>
                  </div>
                </div>

                <!-- 评价内容 -->
                <div class="customer_content">
                  <div class="customer_contentText">
                    <span>{{ itemInfo.content }}</span>
                  </div>

                  <!-- 图片 -->
                  <div class="customer_contentImgBox">
                    <div
                      class="customer_contentImg"
                      v-for="(itemPic,indexPic) in itemInfo.pic_arr"
                      :key="indexPic"
                    >
                      <img :src="itemPic" alt="图片" />
                    </div>
                  </div>
                  <!-- 商家回复 -->
                  <div class="customer_contentReply" v-if="itemInfo.shop_review != ''">
                    <span>
                      <span class="contentReply_name">{{ evData.shangjiahuifu }}:</span>
                      {{itemInfo.shop_review}}
                    </span>
                    <!-- 三角形 -->
                    <div class="customer_replySanjiao"></div>
                  </div>

                  <!-- 用户追评内容 -->
                  <div class="afterReview" v-if="itemInfo.user_review != '' || itemInfo.add_pic_arr.length">
                    <span class="user_review">{{ evData.yonghuzhuiping }}: {{ itemInfo.add_input_time }}</span>
                    <div class="customer_contentText">
                      <span>{{ itemInfo.user_review }}</span>
                    </div>

                    <!-- 图片 -->
                    <div class="customer_contentImgBox" v-if="itemInfo.add_pic_arr.length">
                      <div
                        class="customer_contentImg"
                        v-for="(itemPicAdd,indexPicAdd) in itemInfo.add_pic_arr"
                        :key="indexPicAdd"
                      >
                        <img :src="itemPicAdd" alt="图片" />
                      </div>
                    </div>
                    <!-- 商家回复 -->
                    <div class="customer_contentReply" v-if="itemInfo.add_shop_review != ''">
                      <span>
                        <span class="contentReply_name">{{ evData.shangjiahuifu }}:</span>
                        {{itemInfo.add_shop_review}}
                      </span>
                      <!-- 三角形 -->
                      <div class="customer_replySanjiao"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        

        <div v-if="evData.review_info.length == 0" class="noDataEva">
          <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/emptyArticle.png" alt="empty" />
          <span>{{ evData. zanshihaimeiyouxiangguanpingjia }}</span>
        </div>
        </div>
      </mescroll-vue>

      <mescroll-vue
        ref="mescroll4"
        class="scrollView"
        :up="mescrollUp4"
        :down="mescrollDown"
        @init="mescrollInit4"
        v-show="type == 3"
      >
        <!-- 顶部全部评价 -->
        <div class="container_top">
          <div
            @click="changeMenuStatus(indexEv)"
            :class=" { on: menuList == indexEv } "
            v-for="(itemEv,indexEv) in evData.review_top"
            :key="indexEv"
          >
            <span>
              {{itemEv.title}}
              <span
                class="container_topNumber"
                v-text="parseInt(itemEv.num) <= 999 ? '('+itemEv.num+')' : '('+itemEv.num+')'"
              ></span>
            </span>
          </div>
        </div>
        <div v-if="JSON.stringify(evData) != '{}'">
          <!-- 全部评价 -->
          <div v-if=" evData.review_info.length" class="scrollBox">
            <div v-for="(itemInfo,indexInfo) in evArr4" :key="indexInfo">
               <!-- 客户评论 -->
              <div class="customer_commentsBox">
                <div class="customer_comments">
                  <!-- 头像 -->
                  <div class="customer_headrImg">
                    <img :src="itemInfo.user_pic" alt="头像" />
                  </div>
                  <!-- 名字和评价时间 -->
                  <div class="customer_nameTime">
                    <div>
                      <span>{{ itemInfo.user_name }}</span>
                    </div>
                    <div class="customer_time">
                      <span>{{itemInfo.input_time.slice(0,16)}}</span>
                    </div>
                  </div>
                  <!-- 星星指数 -->
                  <div class="customer_star">
                    <div class="starStyle" v-if="itemInfo.level <= 5 && itemInfo.level >0 ">
                      <img
                        src="https://aimg8.dlssyht.cn/u/1945298/ueditor/image/973/1945298/1569564083831652.png"
                        v-for="(itemStar,indexStar) in parseInt(itemInfo.level)"
                        :key="indexStar"
                        alt="star"
                      />
                    </div>
                    <div class="starStyle" v-if=" (5-parseInt(itemInfo.level)) > 0">
                      <img
                        src="https://aimg8.dlssyht.cn/u/1945298/ueditor/image/973/1945298/1569564136867556.png"
                        alt="noStar"
                        v-for="(itemStarSecond,indexStarSecond) in (5 - parseInt(itemInfo.level))"
                        :key="indexStarSecond"
                      />
                    </div>
                  </div>
                </div>

                <!-- 评价内容 -->
                <div class="customer_content">
                  <div class="customer_contentText">
                    <span>{{ itemInfo.content }}</span>
                  </div>

                  <!-- 图片 -->
                  <div class="customer_contentImgBox">
                    <div
                      class="customer_contentImg"
                      v-for="(itemPic,indexPic) in itemInfo.pic_arr"
                      :key="indexPic"
                    >
                      <img :src="itemPic" alt="图片" />
                    </div>
                  </div>
                  <!-- 商家回复 -->
                  <div class="customer_contentReply" v-if="itemInfo.shop_review != ''">
                    <span>
                      <span class="contentReply_name">{{ evData.shangjiahuifu }}:</span>
                      {{itemInfo.shop_review}}
                    </span>
                    <!-- 三角形 -->
                    <div class="customer_replySanjiao"></div>
                  </div>

                  <!-- 用户追评内容 -->
                  <div class="afterReview" v-if="itemInfo.user_review != '' || itemInfo.add_pic_arr.length">
                    <span class="user_review">{{ evData.yonghuzhuiping }}: {{ itemInfo.add_input_time }}</span>
                    <div class="customer_contentText">
                      <span>{{ itemInfo.user_review }}</span>
                    </div>

                    <!-- 图片 -->
                    <div class="customer_contentImgBox" v-if="itemInfo.add_pic_arr.length">
                      <div
                        class="customer_contentImg"
                        v-for="(itemPicAdd,indexPicAdd) in itemInfo.add_pic_arr"
                        :key="indexPicAdd"
                      >
                        <img :src="itemPicAdd" alt="图片" />
                      </div>
                    </div>
                    <!-- 商家回复 -->
                    <div class="customer_contentReply" v-if="itemInfo.add_shop_review != ''">
                      <span>
                        <span class="contentReply_name">{{ evData.shangjiahuifu }}:</span>
                        {{itemInfo.add_shop_review}}
                      </span>
                      <!-- 三角形 -->
                      <div class="customer_replySanjiao"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
       

        <div v-if="evData.review_info.length == 0" class="noDataEva">
          <img src="https://aimg8.oss-cn-shanghai.aliyuncs.com/xcx_pack/vip_shopmall/emptyArticle.png" alt="empty" />
          <span>{{ evData. zanshihaimeiyouxiangguanpingjia }}</span>
        </div>
         </div>
      </mescroll-vue>
    </div>
  </div>
</template>

<script>
import MescrollVue from "mescroll.js/mescroll.vue";

export default {
  name: "Evaluation",
  components: {
    MescrollVue
  },
  data() {
    return {
      type: 0,
      mescroll: null, // mescroll实例对象
      mescroll2: null, // mescroll实例对象
      mescroll3: null, // mescroll实例对象
      mescroll4: null, // mescroll实例对象
      use: false, //下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的,则mescrollDown可不用写了)
      page: 1,
      page2: 1,
      page3: 1,
      page4: 1,
      evData: {},
      evArr2: [],
      evArr3: [],
      evArr4: [],
      mescrollDown: { use: false },
      evArr: null,
      dataHuifu:'123',
      mescrollUp: {
        // 上拉加载的配置.
        callback: this.loadMore, // 上拉回调,此处简写; 相当于 callback: function(page, mescroll) { }
        evArr: [],
        noMoreSize: 4, //如果列表已无数据,可设置列表的总数量要大于5才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
        htmlNodata: '<p class="upwarp-nodata">'+ '暂无数据' +'</p>'
      },
      mescrollUp2: {
        auto: true,
        // 上拉加载的配置.
        callback: this.loadMore2, // 上拉回调,此处简写; 相当于 callback: function(page, mescroll) { }
        evArr2: [],
        noMoreSize: 4, //如果列表已无数据,可设置列表的总数量要大于5才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
        htmlNodata: '<p class="upwarp-nodata">暂无数据</p>'
      },
      mescrollUp3: {
        auto: true,
        // 上拉加载的配置.
        callback: this.loadMore3, // 上拉回调,此处简写; 相当于 callback: function(page, mescroll) { }
        evArr3: [],
        noMoreSize: 4, //如果列表已无数据,可设置列表的总数量要大于5才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
        htmlNodata: '<p class="upwarp-nodata">暂无数据</p>'
      },
      mescrollUp4: {
        auto: true,
        // 上拉加载的配置.
        callback: this.loadMore4, // 上拉回调,此处简写; 相当于 callback: function(page, mescroll) { }
        evArr4: [],
        noMoreSize: 4, //如果列表已无数据,可设置列表的总数量要大于5才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
        htmlNodata: '<p class="upwarp-nodata">暂无数据</p>'
      },

      // 评价的总数据

      // 中转数组
      evDataArr: {},

      // 评价状态,
      menuList: 0,
      // 评价的总数据
      evData: {},
      // 中转数组
      evDataArr: {},
      getPage: 0
    };
  },
  mounted() {},
  methods: {
    mescrollInit(mescroll) {
      this.mescroll = mescroll;
    },
    mescrollInit2(mescroll) {
      this.mescroll2 = mescroll;
    },
    mescrollInit3(mescroll) {
      this.mescroll3 = mescroll;
    },
    mescrollInit4(mescroll) {
      this.mescroll4 = mescroll;
    },
    // 请求数据方法
    againEvFun(mescroll = null, page) {
      let that = this;
      // var width = document.body.offsetWidth;
      // var wdithpx = width / 2 - 37 / 2;
      // layui.use("layer", function() {
      //   layer.load({
      //     shade: false,
      //     offset: ["50%", wdithpx]
      //   });
      // });

      // 详情信息接口
      this.$F.Response({
        url: "mallorder/api/review.php",
        // param: { username: "banish2015", pro_id: 15343769,type:1,page:0},
        param: {
          username: this.$route.query.username,
          pro_id: this.$route.query.pro_id,
          type: this.type,
          page: page
        },
        success: res => {
          if (res.code == 200) {
            // layui.use("layer", function() {
            //   // 关闭loading
            //   layer.closeAll("loading");
            // });
            that.evData = res.data;
            that.evDataArr[this.type] = res.data.review_info;
            // that.dataHuifu=res.data.zanwushuju
            //判断是哪个标签
            switch (parseInt(that.type)) {
              case 0: {
                //如果是第一页需手动置空列表
                if (that.page == 1) that.evArr = [];
                //把请求到的数据添加到列表
                that.evArr = that.evArr.concat(res.data.review_info);
                break;
              }
              case 1: {
                //如果是第一页需手动置空列表
                if (that.page2 == 1) that.evArr2 = [];
                //把请求到的数据添加到列表
                that.evArr2 = that.evArr2.concat(res.data.review_info);
                break;
              }
              case 2: {
                //如果是第一页需手动置空列表
                if (that.page3 == 1) that.evArr3 = [];
                //把请求到的数据添加到列表
                that.evArr3 = that.evArr3.concat(res.data.review_info);
                break;
              }
              case 3: {
                //如果是第一页需手动置空列表
                if (that.page4 == 1) that.evArr4 = [];
                //把请求到的数据添加到列表
                that.evArr4 = that.evArr4.concat(res.data.review_info);
                break;
              }
            }
            this.$nextTick(() => {
              mescroll.endByPage(
                res.data.review_info.length,
                parseInt(res.data.page_cnt)
              );
              // mescroll.hideUpScroll(true);
              // mescroll.endUpScroll(false)
            });
            if (res.data.review_info.length == 0) {
              mescroll.endUpScroll(true);
            }
          }else{
             //弹出警示信息
          layui.use("layer", function() {
            layer.alert(res.msg, {
              icon: 0,
              skin: "layer-ext-moon"
            });
          });
          }
        },
        error: () => {
          //联网失败的回调,隐藏下拉刷新和上拉加载的状态;
          this.mescroll.endErr();
          // layui.use("layer", function() {
          //   // 关闭loading
          //   layer.closeAll("loading");
          // });
          //弹出警示信息
          layui.use("layer", function() {
            layer.alert("请求失败", {
              icon: 0,
              skin: "layer-ext-moon"
            });
          });
        }
      });
    },

    loadMore(page, mescroll) {
      this.page = page.num;
      mescroll.setPageSize(4);
      this.againEvFun(mescroll, this.page);
      // mescroll.resetUpScroll( false );
    },
    loadMore2(page, mescroll) {
      this.page2 = page.num;
      mescroll.setPageSize(4);
      if (this.type == 1) {
        mescroll.resetUpScroll(false);
        this.againEvFun(mescroll, this.page2);
      }
    },
    loadMore3(page, mescroll) {
      this.page3 = page.num;
      mescroll.setPageSize(4);
      if (this.type == 2) {
        this.againEvFun(mescroll, this.page3);
      }
    },
    loadMore4(page, mescroll) {
      this.page4 = page.num;
      mescroll.setPageSize(4);
      if (this.type == 3) {
        this.againEvFun(mescroll, this.page4);
      }
    },

    // 跳转方法
    switchTo(path) {
      //$router中的path是当前的路由路径
      // this.$router.replace({
      //   path: path,
      //   query: {
      //     username: this.$route.query.username,
      //     pro_id: this.$route.query.pro_id
      //   }
      // });

      window.location.href=this.$route.query.locationUrl
    },
    // 评价切换
    changeMenuStatus(index) {
      let that = this;
      that.menuList = index;
      this.type = index;
      if (that.evDataArr[index] != undefined) {
        that.evData.review_info = that.evDataArr[index];
      } else {
        switch (parseInt(index)) {
          case 1:
            that.againEvFun(this.mescroll2, 1);
            break;
          case 2:
            that.againEvFun(this.mescroll3, 1);
            break;
          case 3:
            that.againEvFun(this.mescroll4, 1);
            break;
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
/*  引入外部scss文件 */
@import "../../../static/css/evaluation.scss";
</style>



// WEBPACK FOOTER //
// src/pages/Evaluation/Evaluation.vue